<template>
  <!-- The heading scale. The level (`as`) follows the page outline; the size
       follows the heading's role, so an <h2> on the generator and an <h2> on a
       marketing page can differ in size without a class string per page.

       display  page title (h1)                      4xl → 5xl
       title    marketing section / app page title   3xl → 4xl
       headline panel or card headline               2xl
       section  content section inside a page        lg
       item     card and list item titles            base -->
  <component :is="as" class="text-white" :class="SIZES[size]">
    <slot />
  </component>
</template>

<script setup>
defineProps({
  as: { type: String, default: 'h2' },
  size: { type: String, default: 'section' },
})

const SIZES = {
  display: 'text-4xl font-bold tracking-tight sm:text-5xl',
  title: 'text-3xl font-bold tracking-tight sm:text-4xl',
  headline: 'text-2xl font-bold tracking-tight',
  section: 'text-lg font-bold',
  item: 'text-base font-semibold',
}
</script>
